import { useContext, useEffect } from 'react'
import moment from 'moment'
import { Checkbox, FormContainer, FormField, Heading, Text, WithFormFeedback } from 'ab-uitools-legacy'

import { useGetAppOffer, useGetShoppingDetails, useProfile, useSubmitLoanterms } from '../../hooks'
import { LOAN_DETAILS_LINK, LOAN_MAIN_DETAILS_LINK, USEFUL_LINKS } from '../../consts'
import { OfferContext, ScheduleContext } from '../../context'

import { formatPhoneNumber } from '../PersonalDetails/utils'
import FormSubmitButton from '../FormSubmitButton'
import withWrapper from '../FormWrapper'

import LoanDetails from './LoanDetails'
import {
  LOAN_CONDITION_1,
  LOAN_CONDITION_2,
  LOAN_CONDITION_3,
  LOAN_CONDITION_INITIAL_VALUES,
  LOAN_CONDITION_VALIDATION_SCHEME
} from './consts'

import { TShoppingDetail } from '../../types'
import './index.scss'
import { maskTestEnvValue } from '../../utils'

const LoanConfirmation = () => {
  const { shoppingData, getShoppingDetails } = useGetShoppingDetails()
  const { scheduleData } = useContext(ScheduleContext)
  const { profileInfo, getProfile } = useProfile()
  const { offers } = useContext(OfferContext)

  const { getAppOffers } = useGetAppOffer()
  const { date, totalAmount } = scheduleData[0]

  const offer = offers[0]
  const { actualInterestRate } = useContext(ScheduleContext)

  const { name, lastname, patronymic, contactPhone, contactEmail, identificationDocument } =
    profileInfo

  const { setLoanTermsForSubmit } = useSubmitLoanterms()
  const { submitLoanTerms } = useSubmitLoanterms()


  const handleSubmit = (data) => {
    setLoanTermsForSubmit(data)
    submitLoanTerms()
  }

  useEffect(() => {
    getProfile()
    getShoppingDetails()
  }, [])

  useEffect(() => {
    if (offers.length === 0) {
      getAppOffers()
    }
  }, [])

  if (!offer || !profileInfo) {
    return null
  }

  return (
    <div className="loan_confirmation">
      <Heading size="xsmall" className="mb-24 header_strong">
        Գնորդի անձնական տվյալներ
      </Heading>

      <div className="loan_confirmation_profile_info_container card_box">
        <div className="profile_row">
          <span className="profile_label">ԱԱՀ</span>
          <span className="profile_value bold">{maskTestEnvValue(`${name} ${lastname} ${patronymic}`)}</span>
        </div>
        
        <div className="profile_row">
          <span className="profile_label">Անձնագիր</span>
          <span className="profile_value">{maskTestEnvValue(identificationDocument?.number)}</span>
        </div>
        
        <div className="profile_row">
          <span className="profile_label">Հեռախոսահամար</span>
          <span className="profile_value">{maskTestEnvValue(formatPhoneNumber(contactPhone))}</span>
        </div>
        
        {contactEmail && contactEmail.emailAddress ? (
          <div className="profile_row">
            <span className="profile_label">Էլ. հասցե</span>
            <span className="profile_value">{contactEmail.emailAddress}</span>
          </div>
        ) : null}
      </div>

     
      <Heading size="xsmall" className="mb-24 mt-24 header_strong">
        Գնվող ապրանքատեսականին
      </Heading>

      <div className="loan_confirmation_profile_info_container card_box ">
        <div className="profile_row">
          <span className="profile_label">Անվանում</span>
          <span className="profile_label">Գումար</span>
        </div>
        <div className="loan_confirmation_divider" />

        {shoppingData.map((shoppingItem: TShoppingDetail, index: number) => {
          const isLastItem = index === shoppingData.length - 1
          return (
            <div>
              <div className="profile_row">
                <span className="profile_value bold">{shoppingItem.name} {shoppingItem.count.toString()} հատ</span>
                <span className="profile_value bold">{shoppingItem.totalPrice}</span>
              </div>
              {!isLastItem ? <div className="loan_confirmation_divider" /> : null}
            </div>
          )
        })}
      </div>
      
      <Heading size="xsmall" className="mb-24 mt-24 header_strong">
        Ապառիկի տվյալներ
      </Heading>
      <div className="loan_confirmation_profile_info_container card_box">
        <div className="profile_row">
          <span className="profile_label">Ընդհանուր գումար</span>
          <span className="profile_label">Տոկոսադրույք</span>
        </div>
        <div className="profile_row">
          <span className="profile_value bold large">{offer?.maxAmount} {offer?.currencyCode}</span>
          <span className="profile_value bold large">{offer?.interest}%</span>
        </div>
      </div>

      <FormContainer
        onSubmit={handleSubmit}
        validationScheme={LOAN_CONDITION_VALIDATION_SCHEME}
        initialValues={LOAN_CONDITION_INITIAL_VALUES}
      >
        <>
          <WithFormFeedback>
            {({ setValue }) => {

              return (
                <LoanDetails setValue={setValue} />
              )
            }}
          </WithFormFeedback>

          <div className="loan_confirmation_info_container card_box">
            <div className="loan_details_display_row">
              {date ? (
                <div className="loan_details_display_field">
                  <span className="display_label">Առաջին վճ․ ամաթիվ</span>
                  <span className="display_value">{moment(date).format('DD.MM.YYYY').toString()}</span>
                </div>
              ) : null}
              <span className="spacer" />
              {totalAmount ? (
                <div className="loan_details_display_field">
                  <span className="display_label">Ամենամսյա վճար</span>
                  <span className="display_value">{totalAmount.toString()}</span>
                </div>
              ) : null}
            </div>
          </div>

          <div className="info_container">
            <Text className="big_label">
              <span>
                Քաղվածքների ստացման տարբերակ՝
                <span className="bold"> {contactEmail.emailAddress} </span>
                Էլեկտրոնային հասցե
              </span>
            </Text>

            <Text className="big_label mt-24">
              <span>Սույնով հաստատում եմ, որ գիտակցում եմ, որ տարեկան փաստացի տոկոսադրույքի չափը կազմում է`
                  <span className="bold"> {actualInterestRate} %</span>
              </span>
            </Text>
            <div className="loan_confirmation_divider" />
            
          </div>
          
          <FormField
            className="mb-24"
            isControlled
            isNeedChangeHandler
            name={LOAN_CONDITION_1}
            As={(props) => (
              <Checkbox
                {...props}
                label={
                  <Text>
                    <>
                      {`Ընդունում եմ `}
                      <a
                        className="loan_details_link"
                        href={LOAN_DETAILS_LINK}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {'Ապառիկ ֆինանսավորման ծառայության պայմանները, '}
                      </a>
                      <a
                        className="loan_details_link"
                        href={LOAN_MAIN_DETAILS_LINK}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {`Սակագները, `}
                      </a>
                      <a
                        className="loan_details_link"
                        href={USEFUL_LINKS}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {`Ֆիզիկական անձանց սպասարկման ընդհանուր պայմանները `}
                      </a>
                      և դրանցում ներառված համաձայնությունները:
                    </>
                  </Text>
                }
              />
            )}
          />
          <FormField
            className="mb-24"
            isControlled
            isNeedChangeHandler
            name={LOAN_CONDITION_2}
            As={(props) => (
              <Checkbox
                {...props}
                label={<Text>Համաձայն եմ նշված պայմաններով սույն Օֆերտան բանկ ուղարկելուն</Text>}
              />
            )}
          />
          <FormField
            className="mb-24"
            isControlled
            isNeedChangeHandler
            name={LOAN_CONDITION_3}
            As={(props) => (
              <Checkbox
                {...props}
                onClick={(value) => {
                  setLoanTermsForSubmit({})
                }}
                label={
                  <Text>
                    <>
                      {`Հաստատում եմ, որ ծանոթացել եմ և համաձայն եմ `}
                      <a
                        className="link"
                        href="https://ameriabank.am/Portals/0/files/General/standard_arbitration_form.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        արբիտրաժային համաձայնագրով սահմանված դրույթներին
                      </a>
                    </>
                  </Text>
                }
              />
            )}
          />
          <Text className="big_label label_hint">
            <span>
              <span className="bold">«Ուղարկել Բանկ»</span> կոճակը սեղմելով հաստատում եմ, որ իմ կողմից Բանկին ուղղված
              ֆինանսավորման ստացման օֆերտան կներկայացվի Բանկ
            </span>
          </Text>
          <FormSubmitButton buttonText="Ուղարկել բանկ" />
        </>
      </FormContainer>
    </div>
  )
}

export default withWrapper(LoanConfirmation)
